import { NgModule } from '@angular/core';
import { MaterialModule, SharedModule } from '@app/shared';
import { JobSelectionScanModalComponent } from './job-selection-scan-modal.component';
@NgModule({
  declarations: [JobSelectionScanModalComponent],
  imports: [MaterialModule, SharedModule],
  entryComponents: [JobSelectionScanModalComponent]
})
export class JobSelectionScanModalModule { }
